var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gap-50 d-flex flex-column p-20 justify-content-center container",
    },
    _vm._l(_vm.resultPage.tools?.groups, function (tool, group) {
      return _vm.isSelectedGroup(group)
        ? _c("div", { staticClass: "w-100" }, [
            _c(
              "div",
              { staticClass: "file-container" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "px-3 align-items-center bg-white p-3 font-weight-bold d-flex justify-content-space-between",
                    class: _vm.borderBottom(tool.color),
                  },
                  [
                    _c("span", { staticClass: "font-size-125" }, [
                      _vm._v(_vm._s(tool.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "text-muted font-weight-bold" },
                        [
                          _vm.isAllSelected && _vm.selectedOutputs.length !== 1
                            ? _c(
                                "div",
                                { staticClass: "m-0 alert alert-info" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm._f("trans")("All files")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isNoneSelected
                            ? _c(
                                "div",
                                { staticClass: "m-0 alert alert-warning" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("trans")("No files selected")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isNoneSelected &&
                          !_vm.isAllSelected &&
                          _vm.selectedOutputs.length !== 1
                            ? _c(
                                "div",
                                { staticClass: "m-0 alert alert-info" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.selectedOutputs.length) +
                                      " " +
                                      _vm._s(_vm._f("trans")("Files")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedOutputs.length === 1
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "m-0 alert alert-info short-text-name",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("decodeUrl")(
                                          _vm.getSingleSelectedFilename()
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm._l(tool.features_detail, function (feature, operation) {
                  return _c(
                    "div",
                    {
                      staticClass:
                        "file-item px-3 d-flex justify-content-between",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "item d-inline-flex gap-10px align-items-center",
                        },
                        [
                          _c("div", { class: _vm.getIcon(tool) }, [
                            _c("i", {
                              staticClass: "lh-inherit far",
                              class: feature.icon,
                            }),
                          ]),
                          _vm._v(
                            "\n        " + _vm._s(feature.name) + "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn d-flex align-items-center btn-info gap-50",
                            class: {
                              disabled:
                                _vm.selectedOutputs.length === 0 ||
                                _vm.currentJob.state === "failed",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openContinue(feature.operation)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("trans")("Continue with")) + " "
                            ),
                            _c("i", { staticClass: "fa fa-arrow-right" }),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }